module.exports = __webpack_public_path__ + "static/miljo3-2a641ae9505a20f9f3cc7b2ac478190e.jpeg";